import React from "react";

function LockIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.44798 5.38281H1.42054L0.803043 5.69156L0.494295 6.30906L0.185547 10.6315L0.494295 11.249L1.11179 11.5578H8.83049H9.75673L10.3742 10.9403V6.92655V5.69156L9.44798 5.38281Z"
        fill="white"
        stroke="black"
        stroke-width="0.1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.43396 0.679245C4.77342 0.679245 4.13994 0.941643 3.67287 1.40872C3.20579 1.87579 2.9434 2.50927 2.9434 3.16981V5.09434H7.92453V3.16981C7.92453 2.50927 7.66213 1.87579 7.19506 1.40872C6.72799 0.941643 6.0945 0.679245 5.43396 0.679245ZM8.60377 5.09434V3.16981C8.60377 2.32912 8.26981 1.52287 7.67536 0.928416C7.0809 0.333961 6.27465 0 5.43396 0C4.59328 0 3.78702 0.333961 3.19257 0.928416C2.59811 1.52287 2.26415 2.32912 2.26415 3.16981V5.09434H1.4717C0.658902 5.09434 0 5.75324 0 6.56604V10.5283C0 11.3411 0.658902 12 1.4717 12H9.39622C10.209 12 10.8679 11.3411 10.8679 10.5283V6.56604C10.8679 5.75324 10.209 5.09434 9.39622 5.09434H8.60377ZM1.4717 5.77359C1.03404 5.77359 0.679245 6.12838 0.679245 6.56604V10.5283C0.679245 10.966 1.03404 11.3208 1.4717 11.3208H9.39622C9.83389 11.3208 10.1887 10.966 10.1887 10.5283V6.56604C10.1887 6.12838 9.83389 5.77359 9.39622 5.77359H1.4717Z"
        fill="#1F2430"
      />
      <circle cx="5.43402" cy="8.54827" r="0.849057" fill="#1F2430" stroke="black" stroke-width="0.1" />
    </svg>
  );
}

export default LockIcon;
